
import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

// Hardcoded fallback subtopics for ES when state is unavailable
const ALL_ES_SUBTOPICS = [
    { name: 'Overview of Embedded Systems, Design challenges, Embedded processor technology, Hardware Design', path: '/es-m1-s1' },
    { name: 'Micro-controller architecture -8051, PIC, and ARM', path: '/es-m1-s2' },
    { name: 'ADC DAC', path: '/es-m2-s1' },
    { name: 'Timers & Counters, watchdog Timer, UART, Encoders/decoders', path: '/es-m2-s2' },
    { name: 'Sensors and actuators interfacing', path: '/es-m2-s3' },
    { name: 'Evolution of Embedded Programming Tools, Modelling Programs, Code Optimization, Logic Analyzers, Programming Environment', path: '/es-m4-s1' },
    { name: 'Classification of Real Time Systems, Issues & Challenges in RTS', path: '/es-m5-s1' },
    { name: 'Real Time Scheduling Schemes - EDF, RMS & Hybrid Techniques', path: '/es-m5-s2' }
];

const ESModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_ES_SUBTOPICS, subjectPath = '/subject-ESModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_ES_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default ESModuleSubtopic;
